import * as React from 'react';
import { createPortal } from 'react-dom';
import * as PropTypes from 'prop-types';
import { useState, useEffect, useRef } from 'react';

import {
  ModalOverlay,
  ModalStyled,
  ModalIcon
} from './styled';

import { Icon } from './../Icon';

interface Props {
  width?: string;
  maxWidth?: string;
  minWidth?: string;
  height?: string;
  children?: React.ReactNode;
  openModal?: boolean;
  closeModal?: Function;
}

export const Modal: React.FC<Props> = ({
  width,
  maxWidth,
  minWidth,
  height,
  openModal,
  children,
  closeModal,
  ...rest
}) => {

  const [ open, setOpen ] = useState(openModal);
  const ref = useRef(null);

  let contentBody = document.getElementsByTagName('body')[0];

  useEffect(() => {
    openModal ? (contentBody.style.overflow = 'hidden') : (contentBody.style.overflow = '');
    setOpen(openModal);
  }, [openModal]);

  const handleClick = (e) => {
    if(e.currentTarget === e.target || ref.current.contains(e.target)) {
      setOpen(false);
      contentBody.style.overflow = '';
      closeModal();
    }
  }

  return(
    <>
      {createPortal(
        <>
          {
            open && (
              <ModalOverlay onClick={(e) => handleClick(e)}>
                <ModalStyled
                  width={width}
                  maxWidth={maxWidth}
                  minWidth={minWidth}
                  height={height}
                >
                  <ModalIcon
                    ref={ref}
                    data-test="detailPopupClose"
                    onClick={(e) => handleClick(e)}>
                    <Icon name="x"/>
                  </ModalIcon>
                  {children}
                </ModalStyled>
              </ModalOverlay>
            )
          }
        </>,
        contentBody
      )}
    </>
  );
}

Modal.propTypes = {
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  minWidth: PropTypes.string,
  height: PropTypes.string,
  children: PropTypes.node,
  openModal: PropTypes.bool,
  closeModal: PropTypes.func
}
